import Axios from 'axios'

export default {
    namespaced: true,

    state: {
        token: null,
        user: null,
    },
    getters: {
        authenticated(state) {
            return state.token && state.user
        },
        user(state) {
            // console.log(state)
            return state.user
        },
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
            console.log(state.token)
        },
        SET_USER(state, data) {
            state.user = data
        },
    },
    actions: {
        async signIn({dispatch}, credentials) {
            //  console.log(credentials)
            try{
                let response = await Axios.post('auth/login', credentials)
                console.log(response.data)
                dispatch('attempt', response.data.token)
                return response
            }catch(e){
                console.log(e.response)
                throw e.response.data.message
            }
        },

        async verifyOtp({dispatch}, otpCode) {
            try{
                let response = await Axios.post('auth/verify-otp', otpCode)
                console.log(response.data)
                dispatch('attempt', response.data.token)
                return response

            }catch(e){
                throw e.response.data.message
                // console.log(e.response)
            }
        },
        async resendOtp ({dispatch}) {
            try{
                let response = await Axios.get('auth/resend-otp')
                console.log(response.data)
                return response
            }catch(e){
                throw e.response.data.message
            }
        },

        async attempt({commit, state}, token) {
            //console.log(token)
            if (token) {
                console.log('set token')
                commit('SET_TOKEN', token)
            }
            
            if (!state.token) {
                return
            }

            try {
                // console.log('as')
                let response = await Axios.get('auth/me')
                commit('SET_USER', response.data.userData) //FI ERROR HENA
            } catch (error) {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
            }
        },
        SignOut({commit}) {
            return Axios.get('auth/logout').then(() => {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
            })
        }
    }

}
